import { Card as MantineCard } from "@mantine/core";
import styles from "./card.module.scss";
import type { CustomCardFactory, IProps } from "./card.types";
import { polymorphicComponentWrapper } from "../../utilities";

const Card = polymorphicComponentWrapper<CustomCardFactory, IProps>("Card", (props, ref) => {
    return <MantineCard ref={ref} classNames={{ root: styles["root"], section: styles["section"] }} {...props} />;
});

export { Card };
